<template>
    <main id="dashboard">
        <div class="container mx-auto">
            <div class="breadcumb">
                <div class="breadcumb__left">
                    <p class="breadcumb__title">Contact</p>
                </div>
                <div class="breadcumb__right">
                    <button class="date">
                        <i class="far fa-calendar-alt date__icon"></i>
                        <span>Lifetime</span>
                        
                        <div class="date__caret">
                            <i class="fas fa-caret-down"></i>
                        </div>
                    </button>
                </div>
            </div>

            <div class="flex flex-wrap -mx-3">
                <div class="px-3 pb-6 w-full sm:w-1/2 md:w-1/4">
                    <div class="card card--overview">
                        <h3 class="card--overview__val">0</h3>
                        <div class="card--overview__label">
                            <i class="fa fa-users"></i>
                            <span>Total Contact</span>
                        </div>
                    </div>
                </div>
                <div class="px-3 pb-6 w-full sm:w-1/2 md:w-1/4">
                    <div class="card card--overview">
                        <h3 class="card--overview__val">0</h3>
                        <div class="card--overview__label">
                            <i class="fa fa-user-tag"></i>
                            <span>Total Customer</span>
                        </div>
                    </div>
                </div>
                <div class="px-3 pb-6 w-full sm:w-1/2 md:w-1/4">
                    <div class="card card--overview">
                        <h3 class="card--overview__val">0x</h3>
                        <div class="card--overview__label">
                            <i class="fa fa-cart-arrow-down"></i>
                            <span>Average Order</span>
                        </div>
                    </div>
                </div>
                <div class="px-3 pb-6 w-full sm:w-1/2 md:w-1/4">
                    <div class="card card--overview">
                        <h3 class="card--overview__val">Rp 0</h3>
                        <div class="card--overview__label">
                            <i class="fa fa-credit-card"></i>
                            <span>ARPC/ARPU <i class="fa fa-info-circle" v-tooltip.top-center="'Info tambahan disini'"></i></span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-action flex flex-wrap -mx-2 mt-6 w-full md:w-auto pb-4">
                <div class="px-1 w-auto mb-3">
                    <button class="btn btn-xs btn-base">
                        <i class="fas fa-address-book"></i>
                        Upload Contacts
                    </button>
                </div>

                <div class="px-1 w-auto mb-3">
                    <button class="btn btn-xs btn-base">
                        <i class="fas fa-download"></i>
                        Export as CSV
                    </button>
                </div>
            </div>

            <div class="table-wrapper">
                <div class="flex flex-wrap justify-between items-center">

                    <div class="table-action flex flex-wrap -mx-2 w-full md:w-auto pb-4">
                        <div class="px-1 w-auto mb-3">
                            <button class="btn btn-round-less btn-xxs btn-primary">
                                <i class="fas fa-plus"></i>
                                Add Contact
                            </button>
                        </div>

                        <div class="px-1 w-auto mb-3">
                            <button class="btn btn-round-less btn-xxs btn-base">
                                <i class="fas fa-bell"></i>
                                Create Reminder
                            </button>
                        </div>

                        <div class="px-1 w-auto mb-3">
                            <button class="btn btn-round-less btn-xxs btn-base">
                                <i class="fas fa-trash"></i>
                                Delete
                            </button>
                        </div>

                        <div class="px-1 w-auto mb-3">
                            <button class="btn btn-round-less btn-xxs btn-base">
                                <i class="fas fa-tag"></i>
                                Set Tag
                            </button>
                        </div>
                    </div>

                    <div class="form-set w-full md:w-auto">
                        <!-- <label>
                            <strong>Harga Reguler</strong>
                        </label> -->
                        <input type="search" placeholder="Cari">
                    </div>
                </div>

                <div class="tw">
                    <table class="table">
                        <thead>
                        <tr>
                            <th>
                                <label class="cbx-set _center">
                                    <input type="checkbox">
                                    <div class="_box"></div>
                                </label>
                            </th>
                            <th>Name</th>
                            <th class="hidden sm:table-cell">Tags</th>
                            <th class="hidden sm:table-cell">Email</th>
                            <th class="hidden sm:table-cell">Phone</th>
                            <th class="hidden sm:table-cell">Paid Orders</th> 
                            <th class="hidden sm:table-cell">Lifetime Value (LTV)</th> 
                            <th class="hidden sm:table-cell">Date</th> 
                            <th class="hidden sm:table-cell">Last Contacted</th> 
                        </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="align-top sm:align-middle">
                                    <label class="cbx-set _center">
                                        <input type="checkbox">
                                        <div class="_box"></div>
                                    </label>
                                </td>
                                <td class="sm:hidden">
                                    <div class="_wrapper">
                                        <div class="_cont">
                                            <a class="main-link" href="#!">
                                                Ahmad Fauzan
                                                <i class="fa fa-dollar-sign _coin"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="_wrapper">
                                        <div class="_title">Tag</div>
                                        <div class="_cont">
                                            <a href="#!"><i class="fa fa-tag"></i> Add Tag</a>
                                        </div>
                                    </div>
                                    <div class="_wrapper">
                                        <div class="_title">Email</div>
                                        <div class="_cont">
                                            <a href="mailto:email@example.com">email@example.com</a>
                                        </div>
                                    </div>
                                    <div class="_wrapper">
                                        <div class="_title">Phone</div>
                                        <div class="_cont">081234567890</div>
                                    </div>
                                    <div class="_wrapper">
                                        <div class="_title">Paid Orders</div>
                                        <div class="_cont">1</div>
                                    </div>
                                    <div class="_wrapper">
                                        <div class="_title">Lifetime Value (LTV)</div>
                                        <div class="_cont">Rp 390.092</div>
                                    </div>
                                    <div class="_wrapper">
                                        <div class="_title">Date</div>
                                        <div class="_cont">28 November 2020, 12:25</div>
                                    </div>
                                    <div class="_wrapper">
                                        <div class="_title">Last Contacted</div>
                                        <div class="_cont">6th May 2020, 08.02</div>
                                    </div>
                                    <div class="_wrapper">
                                        <div class="_cont">
                                            <button class="btn btn-w-xs btn-xs btn-error mb-4"><i class="fa fa-trash"></i> Hapus</button>
                                        </div>
                                    </div>
                                </td>
                                <td class="hidden sm:table-cell">
                                    <a class="main-link" href="#!">
                                        Ahmad Fauzan
                                        <i class="fa fa-dollar-sign _coin"></i>
                                        </a>
                                    <div class="sub-content">
                                        <button class="_error"><i class="fa fa-trash"></i> Hapus</button>
                                    </div>
                                </td>
                                <td class="hidden sm:table-cell">
                                    <a href="#!"><i class="fa fa-tag"></i> Add Tag</a>
                                </td>
                                <td class="hidden sm:table-cell text-center">
                                    <a href="mailto:email@example.com">email@example.com</a>
                                </td>
                                <td class="hidden sm:table-cell text-center">081234567890</td>
                                <td class="hidden sm:table-cell text-center">1</td>
                                <td class="hidden sm:table-cell text-center">Rp 390.092</td>
                                <td class="hidden sm:table-cell text-center">28 November 2020, 12:25</td>
                                <td class="hidden sm:table-cell text-center">6th May 2020, 08.02</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    import $ from 'jquery'

    export default {
        mounted () {

            $('th input[type="checkbox"]').click(function(){
                if ($(this).prop('checked')) {
                    $(this).parents('table').find('tbody tr td input[type="checkbox"]').prop('checked', true);
                } else {
                    $(this).parents('table').find('tbody tr td input[type="checkbox"]').prop('checked', false);
                }
            });
        }
    }
</script>

<style lang="sass" scoped>
@import ~@/sass/main

.table-wrapper
    position: relative

    .table-action
        top: 44px
        left: 16px

table
    thead
        tr
            th
                    
                &:nth-child(2),
                &:nth-child(4),
                &:nth-child(5),
                &:nth-child(7),
                &:nth-child(8),
                &:nth-child(9)
                    text-align: left

                &:last-child
                    width: 126px
                    
    
    tbody
        tr
            td
                &:nth-child(1)
                    width: 40px
                    
                &:nth-child(2),
                &:nth-child(4),
                &:nth-child(5),
                &:nth-child(7),
                &:nth-child(8),
                &:nth-child(9)
                    text-align: left

                img
                    background-color: mix($color-gray, black, 90%)
                    border-radius: 4px

                .follow-up

                    ._list
                        width: 28px
                        height: 28px
                        line-height: 28px
                        text-align: center
                        font-size: 12px
                        color: white
                        background-color: mix($color-gray, black, 90%)
                        border-radius: 50%

                        &._ballon
                            position: relative

                            &::after
                                position: absolute
                                display: block
                                content: ''
                                bottom: -1px
                                left: 1px
                                transform: rotate(36deg)
                                width: 0
                                height: 0
                                border-left: 0px solid transparent
                                border-right: 6px solid transparent
                                border-top: 5px solid mix($color-gray, black, 90%)
                                

                        &._done
                            background-color: $color-primary

                            &._ballon

                                &::after
                                    border-top-color: $color-primary

                .sub-content
                    overflow: hidden
                    height: 0
                    opacity: 0
                    margin-top: 4px
                    transition: all .2s ease-in-out .2s, opacity .2s ease-in-out

            &:hover

                td
                    .sub-content
                        opacity: 1
                        height: 20px
                        transition: all .2s ease-in-out, opacity .2s ease-in-out .2s
                                    
</style>